import { useEffect, useState } from 'react'
import { Select, SelectChangeEvent, MenuItem, FormControl, OutlinedInput, Box} from '@mui/material'
import { Regions } from 'src/constant/Region';
import ManageRegion from './ManageRegion';
import { useStorageStore } from 'src/stores/StorageStore';
import { useDialogStore } from 'src/stores/DialogStore';
import { AlertSpan } from './CommonStyled';

//사용자 데이터로부터 기본값을 받아옴
//ManageRegion 을 사용해 Chips 표현

const RegionSelector = () => {
    const contents = Regions
    const menuProps = {
        PaperProps: {
            sx: {
              maxHeight: '200px',
              overflowY: 'auto',
            },
          },
          TransitionProps: {
            onEntering: (menuElement: HTMLElement) => {
              menuElement.scrollTop = 0;
            },
          },
    }
    const sx = {
            height:46
    }
    const [wideloc,setWideLoc] = useState('')
    const [cityloc,setCityLoc] = useState('')
    const getUserdata = useStorageStore().getItem('user').data.user_area
    const selected_Regions = useDialogStore((state)=>state.selected_Regions)
    const locations = useDialogStore((state)=>state.locations)
    const setLocations = useDialogStore((state)=>state.setLocations)
    const setRegions = useDialogStore((state)=>state.setRegions)
    const [isvalid,setIsvalid] = useState(true)

    useEffect(() => {
      const init = async () => {
        if (selected_Regions && Object.keys(selected_Regions).length > 0) {
          await setLocations(selected_Regions); // ✅ selected_Regions가 있으면 그걸로
        } else {
          await setLocations(getUserdata); // ✅ 없으면 기본값
        }
      };
      init(); // 🔁 async 함수 실행
      
      if (!selected_Regions || Object.keys(selected_Regions).length === 0) {
        setRegions(); // ✅ selected_Regions가 비었을 때
      }
    }, []);

    const handleKeyChange = (e:SelectChangeEvent<string>)=>{
        setWideLoc(e.target.value)
        if(wideloc){
            setCityLoc('')
        }
    }
    const handleValueChange = (e: SelectChangeEvent<string>) => {
        const newCity_loc = e.target.value;
        setCityLoc(newCity_loc);
        
        let wideKey = wideloc; // 예: "서울특별시" → "서울"
        if (wideloc.endsWith('남도') || wideloc.endsWith('북도')) {
          wideKey =  wideloc[0] + wideloc[2]; // 예: 전라남도 → 전남 (0:'전', 2:'남')
        }
        else{
          wideKey = wideloc.slice(0, 2); // 예: 서울특별시 → 서울
        }
        
        // 현재 상태 복사
        const newLocations = { ...locations };
      
        if (newCity_loc === "전체") {
          newLocations[wideKey] = ["전체"];
        } else {
          const existing = newLocations[wideKey] ?? [];
      
          const updated = existing.filter((item) => item !== "전체");
      
          if (!updated.includes(newCity_loc)) {
            newLocations[wideKey] = [...updated, newCity_loc];
          } else {
            newLocations[wideKey] = updated;
          }
        }
        setLocations(newLocations);
      };

    useEffect(()=>{
      if(!locations || Object.keys(locations).length === 0){
        setIsvalid(false)
        return
      }
      setIsvalid(true)
    },[locations])

  return (
    <>
        <Box sx={{ display: "flex", gap: "15px"}}>
        <FormControl fullWidth>
        <Select
            displayEmpty
            value={wideloc}
            onChange={handleKeyChange}
            renderValue={(selected) => selected as string || "시/도"}
            input={<OutlinedInput notched={false} name="시/도"/>}
            MenuProps={menuProps}
            sx={sx}
            >
            {Object.keys(contents).map((region)=>(
                <MenuItem key={region} value={region}>
                    {region}
                </MenuItem>
            ))}
        </Select>
        </FormControl>
        <FormControl fullWidth >
        <Select
            value={cityloc}
            onChange={handleValueChange}
            renderValue={(selected) => selected || "시/군/구"}
            input={<OutlinedInput notched={false} name="시/군/구"/>}
            disabled={!wideloc}
            MenuProps={menuProps}
            displayEmpty
            sx={sx}>
            {(contents[wideloc] ?? []).map((district)=>(
                <MenuItem key={district} value={district}>
                    {district}
                </MenuItem>
            ))}
        </Select>
        </FormControl>
        </Box>
        <ManageRegion user_area={locations} isModify={false}/>
        {!isvalid &&
          <AlertSpan $isValid={false}>담당 지역을 1개 이상 설정해주세요</AlertSpan>
        }
    </>
  )
}

export default RegionSelector